import { Box, Container, Heading, Stack } from '@hover/blueprint';
import { navigate } from 'gatsby';
import React from 'react';
import { ADD_ARCHITECT_PACKAGE_LINK } from '../../../constants';
import ArrowButton from '../../ui/ArrowButton';

const AddArchitectPackage: React.FC = () => {
  const navigateTo = () => navigate(ADD_ARCHITECT_PACKAGE_LINK);

  return (
    <Container
      maxW="8xl"
      centerContent
      px={{ base: 400, tablet: '56px' }}
      mb="80px"
    >
      <Box
        maxW="1200px"
        w="100%"
        bg="brandTan.100"
        shadow="distance300"
        borderRadius="8px"
        pl={{ base: 500, tablet: 800, desktop: '103px' }}
        pr={{ base: 500, tablet: '87px', desktop: '70px' }}
        py={{ base: 400, tablet: 800, desktop: 900 }}
        flexDir="column"
        alignItems={{ base: 'center', desktop: 'flex-start' }}
      >
        <Heading
          textAlign={{ base: 'center', desktop: 'left' }}
          size={{ base: 500, tablet: 600 }}
          marginBottom={{ base: 0, tablet: '30px', desktop: 600 }}
        >
          Just need access to our 3D model exports - SKP, DWG, or DXF?
        </Heading>
        <Stack
          direction={{ base: 'column', tablet: 'row' }}
          spacing={{ base: 500, desktop: 700 }}
          alignItems="center"
        >
          <Heading
            textAlign="left"
            d={{ base: 'none', tablet: 'inline' }}
            size={{ base: 300, tablet: 500 }}
            isDisplay
            marginBottom={{ base: 0, tablet: 0 }}
          >
            Add a la carte to any plan.
          </Heading>
          <Heading
            textAlign="center"
            d={{ base: 'inline', tablet: 'none' }}
            size={{ base: 300, tablet: 500 }}
            isDisplay
            marginBottom={{ base: 0, tablet: 0 }}
          >
            Add a la carte to any PAYG or Membership plan.
          </Heading>
          <ArrowButton
            colorScheme="primary"
            variant="outline"
            onClick={navigateTo}
          >
            Add architect package
          </ArrowButton>
        </Stack>
      </Box>
    </Container>
  );
};

export default AddArchitectPackage;
